import React, {useState} from 'react';
import {InputModel} from './inputModel';


function InputSample() {
    const model: InputModel={name:'', nickname:''};
    const [inputs, setInputs] = useState(model);
    const [number, setNumber] = useState(0);
    const { name, nickname } = inputs; // 비구조화 할당을 통해 값 추출

    const onChange = (e:any) => {
        const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        setInputs({
            ...inputs, // 기존의 input 객체를 복사한 뒤
            [name]: value // name 키를 가진 값을 value 로 설정
        });
    };

    const onReset = () => {
        model.nickname='';
        model.name='';
        setInputs(model)
        setNumber(number+1);
    };


    return (
        <div>
            <input name="name" placeholder="이름" onChange={onChange} value={name} />
            <input name="nickname" placeholder="닉네임" onChange={onChange} value={nickname}/>
            <button onClick={onReset}>초기화</button>
            <div>
                <b>값: </b>
                {name} ({nickname})
            </div>
            <h1>{number}</h1>
        </div>
    );
}

export default InputSample;
